import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { backend_api } from "../../../../static/server";
import { appendTeamMemberLawyerId } from "../../../../styles/styles";

export const getAllBilles = createAsyncThunk(
  "bille/getAllBilles",
  async ({ url, token, page, pageSize, teamMemberLawyerId }) => {
    try {
      let paginatedUrl = appendTeamMemberLawyerId(url, teamMemberLawyerId);
      const params = [];
      if (page !== undefined) {
        params.push(`page=${page}`);
      }
      if (pageSize !== undefined) {
        params.push(`page_size=${pageSize}`);
      }
      if (params.length > 0) {
        const separator = paginatedUrl.includes("?") ? "&" : "?";
        paginatedUrl = `${paginatedUrl}${separator}${params.join("&")}`;
      }

      const response = await axios.get(paginatedUrl, {
        headers: {
          Authorization: `Token ${token}`,
        },
      });

      return {
        ...response.data,
        pagination: {
          page: page || 1,
          pageSize: pageSize || 10,
          rowCount: response.data.count || 0,
          nextPage: response.data.next,
          previousPage: response.data.previous,
        },
      };
    } catch (error) {
      toast.error("Failed to get billing data");
      throw error.response?.data || error.message;
    }
  }
);

export const updateStatus = createAsyncThunk(
  "bille/updateStatus",
  async ({ id, data, token }) => {
    try {
      const response = await axios.put(
        `${backend_api}firm-case/bill/${id}/`,
        data,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );
      // toast.success("Status update successfully");
      return response.data;
    } catch (error) {
      toast.error("Failed to update billes");
      throw error.response?.data || error.message;
    }
  }
);

export const updateBill = createAsyncThunk(
  "bille/updateBill",
  async ({ id, data, token }) => {
    try {
      const response = await axios.put(
        `${backend_api}firm-case/bill/${id}/`,
        data,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      );
      toast.success("Bill updated successfully");
      return response.data;
    } catch (error) {
      toast.error("Failed to update bill");
      throw error.response?.data || error.message;
    }
  }
);

const BillingSlice = createSlice({
  name: "Billing",
  initialState: {
    allBilles: null,
    loading: false,
    error: null,
    pagination: {
      page: 1,
      pageSize: 10,
      rowCount: 0,
      nextPage: null,
      previousPage: null,
    },
  },
  reducers: {
    setPage: (state, action) => {
      state.pagination.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pagination.pageSize = action.payload;
    },
    resetPagination: (state) => {
      state.pagination = {
        page: 1,
        pageSize: 10,
        rowCount: 0,
        nextPage: null,
        previousPage: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllBilles.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllBilles.fulfilled, (state, action) => {
        state.allBilles = action?.payload?.results || action?.payload;
        state.loading = false;
        if (action.payload.pagination) {
          state.pagination = {
            ...action.payload.pagination,
            count: action.payload.count,
            next: action.payload.next,
            previous: action.payload.previous,
          };
        }
      })
      .addCase(getAllBilles.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload;
      })
      .addCase(updateBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBill.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload;
      });
  },
});

export const { setPage, setPageSize, resetPagination } = BillingSlice.actions;

export const BillingReducer = BillingSlice.reducer;
